export default __webpack_public_path__ + "static/media/about--desktop.dcbc07d1.webp";